import React from 'react'
import PropTypes from 'prop-types'

// FIXME: Duplicate (Step One, Step Two) code needs to be extracted in a module
export default function StepThree({ step, targetUrl, shareUrl, linkTitle }) {
  return (
    <div className={`${step === 3 ? '' : 'd-none'}`}>
      <div className="section-headline container py-0">
        <div className="section-headline__content">
          <div className="row col-12">
            <div className="section-headline__text-container col-12 text-center">
              <h2 className="section-headline__headline">Ihr Empfehlungs-Link</h2>
              <div className="section-headline__subline">
                <strong>
                  Schritt {step} von {step}
                </strong>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <a
            target="_blank"
            href={decodeURIComponent(shareUrl)}
            className="btn btn--small mx-auto mb-1"
            title="Link Title"
            rel="noreferrer"
          >
            <span className="btn__span">Jetzt teilen</span>
          </a>
        </div>
        <div className="container">
          <p className="mb-1">Oder: Persönlichen Link kopieren und an Freunde mailen.</p>
          <div className="socialshare-modal__link">
            <a target="_blank" href={targetUrl} className="link--dynamic" rel="noreferrer" title={linkTitle}>
              <span className="link__text link__text--wrap">
                <span>{targetUrl}</span>
              </span>
            </a>
          </div>
          <a
            target="_blank"
            href="https://www.1und1.de/Datenschutz"
            className="link--dynamic link__text--gray text-center"
            rel="noreferrer"
            title="Hinweise zum Datenschutz"
          >
            <span className="link__text">
              <span>Hinweise zum Datenschutz</span>
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}

StepThree.propTypes = {
  step: PropTypes.number,
  targetUrl: PropTypes.string,
  shareUrl: PropTypes.string,
  linkTitle: PropTypes.string
}
